import { Component, ViewChild } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../components/modal/modal.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { DropdownService } from '../../services/dropdown.service';
import { HeaderComponent } from "../../components/header/header.component";
import { SearchInputComponent } from "../../components/search-input/search-input.component";
import { ButtonComponent } from "../../components/button/button.component";
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { BulkUploadComponent } from "../../components/bulk-upload/bulk-upload.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { ValidationService } from '../../services/validation.service';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { JsonPipe, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-role-page',
  imports: [HeaderComponent, SearchInputComponent, RouterLink, SelectInputComponent, ButtonComponent, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, TextInputComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, NgFor, NgIf, JsonPipe],
  templateUrl: './role-page.component.html',
  styleUrl: './role-page.component.css'
})
export class RolePageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Role';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];

  access: any = [
    { title: 'All', value: 'All' }
  ]


  columns: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'name', headerName: 'Role Name', filter: true, flex: 1, },
    // { field: 'description', headerName: 'Description', filter: true, flex: 1, },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Role Name', type: 'text', return_as: 'name', sample_value: 'Admin' },
    { column_name: 'Role code', type: 'text', return_as: 'code', sample_value: 'AD' },
    { column_name: 'Description', type: 'text', return_as: 'description', sample_value: 'Mumbai' },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.user_management_faculty_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.user_management_rbac_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.user_management_rbac_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.user_management_rbac_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ps: RoleService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      belongs_to: [''],
      role: [''],
      is_active: [true]
    });
  }


  async ngOnInit() {
    //  await this.dds?.get_dropdown_list(['country', 'state']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.ps.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  open_view_modal(item: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/role-permission/form'], {
        queryParams: { id: id, view: true },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }
  async delete() {
    try {
      let res = await this.ps.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('role');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async update(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ps.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('role');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.ps.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.dds.invalidate_dropdown_cache('role');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  // async open_form_modal(item?: any) {
  //   this.selected_ids = item || {};
  //   if (this.selected_ids && this.selected_ids.id) {
  //     let response = await this.ps.get(item.id);
  //     this.selected_ids = { ...response.data };
  //     this.form.patchValue({ ...this.selected_ids, });
  //   } else {
  //     this.selected_ids = {};
  //     this.form.reset();
  //   }
  //   this.form_modal?.open();
  // }

  async open_form_modal(item?: any) {
    const id = item?.id || null;
    if (id) {
      this.route.navigate(['/role-permission/form'], {
        queryParams: { id: id },
        queryParamsHandling: 'merge',
      });
      // this.route.navigate(['/assessment/form', {id:id}]);
    }
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.ps.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ps.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.dds.invalidate_dropdown_cache('role');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.ps, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

}
